import styled from 'styled-components'

export const FormError = styled.span`
  color: ${({ theme }) => theme.colors.state.negative.A};
  font-size: ${({ theme }) => theme.fontSizes.C};
`
